export default __webpack_public_path__ + "static/media/aziz@2x.ccb4650e.png";